import React from 'react';
import { BookOpenIcon, UsersIcon, MessageSquareIcon, AwardIcon, TrendingUpIcon } from 'lucide-react';
interface Notification {
  id: number;
  type: 'course' | 'community' | 'achievement' | 'activity';
  title: string;
  description: string;
  time: string;
  read: boolean;
  icon: React.ReactNode;
}
const notifications: Notification[] = [{
  id: 1,
  type: 'course',
  title: 'Nuovo corso disponibile',
  description: 'È stato pubblicato "Mobilità sostenibile: muoversi meglio, spendere meno"',
  time: '2 ore fa',
  read: false,
  icon: <BookOpenIcon size={18} className="text-green-600" strokeWidth={1.5} data-id="element-1891" />
}, {
  id: 2,
  type: 'community',
  title: 'Nuovo post nel gruppo',
  description: 'Marco ha pubblicato "Trucchi per conservare frutta e verdura" in Zero Sprechi',
  time: '4 ore fa',
  read: false,
  icon: <MessageSquareIcon size={18} className="text-blue-600" strokeWidth={1.5} data-id="element-1892" />
}, {
  id: 3,
  type: 'achievement',
  title: 'Certificato ottenuto!',
  description: 'Hai completato "Climate Change 101: cosa dice la scienza"',
  time: '1 giorno fa',
  read: false,
  icon: <AwardIcon size={18} className="text-yellow-600" strokeWidth={1.5} data-id="element-1893" />
}, {
  id: 4,
  type: 'community',
  title: 'Nuova connessione',
  description: 'Laura Bianchi ha accettato la tua richiesta di connessione',
  time: '2 giorni fa',
  read: true,
  icon: <UsersIcon size={18} className="text-purple-600" strokeWidth={1.5} data-id="element-1894" />
}, {
  id: 5,
  type: 'activity',
  title: 'Gruppo approvato',
  description: 'Il tuo gruppo "Mobilità Smart & Bici" è stato approvato ed è ora pubblico',
  time: '3 giorni fa',
  read: true,
  icon: <TrendingUpIcon size={18} className="text-green-600" strokeWidth={1.5} data-id="element-1895" />
}];
interface NotificationsMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
const NotificationsMenu: React.FC<NotificationsMenuProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;
  const NotificationItem = ({
    notification
  }: {
    notification: Notification;
  }) => <div className={`p-4 border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors ${!notification.read ? 'bg-blue-50/30' : ''}`} data-id="element-1896">
      <div className="flex items-start gap-3" data-id="element-1897">
        <div className="mt-0.5 flex-shrink-0" data-id="element-1898">
          <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-1899">
            {notification.icon}
          </div>
        </div>
        <div className="flex-1 min-w-0" data-id="element-1900">
          <p className="text-sm font-medium text-gray-900" data-id="element-1901">
            {notification.title}
          </p>
          <p className="text-sm text-gray-600 mt-0.5 leading-relaxed font-normal" data-id="element-1902">
            {notification.description}
          </p>
          <p className="text-xs text-gray-400 mt-1.5 font-normal" data-id="element-1903">
            {notification.time}
          </p>
        </div>
        {!notification.read && <div className="w-2 h-2 rounded-full bg-green-600 flex-shrink-0 mt-2" data-id="element-1904"></div>}
      </div>
    </div>;
  const unreadCount = notifications.filter(n => !n.read).length;
  return <div className="absolute right-0 mt-2 w-80 bg-white rounded-xl shadow-xl border border-gray-200 z-50 overflow-hidden" data-id="element-1905">
      <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-1906">
        <div className="flex items-center justify-between" data-id="element-1907">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1908">Notifiche</h3>
          {unreadCount > 0 && <span className="px-2 py-0.5 bg-green-600 text-white text-xs font-medium rounded-full" data-id="element-1909">
              {unreadCount} nuove
            </span>}
        </div>
      </div>
      <div className="max-h-[400px] overflow-y-auto" data-id="element-1910">
        {notifications.length > 0 ? notifications.map(notification => <NotificationItem key={notification.id} notification={notification} data-id="element-1911" />) : <div className="p-8 text-center" data-id="element-1912">
            <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3" data-id="element-1913">
              <BookOpenIcon size={20} className="text-gray-400" strokeWidth={1.5} data-id="element-1914" />
            </div>
            <p className="text-sm text-gray-500 font-normal" data-id="element-1915">
              Nessuna notifica
            </p>
          </div>}
      </div>
      <div className="p-3 text-center border-t border-gray-200 bg-gray-50" data-id="element-1916">
        <button className="text-sm text-green-600 hover:text-green-700 font-medium transition-colors" data-id="element-1917">
          Vedi tutte le notifiche
        </button>
      </div>
    </div>;
};
export default NotificationsMenu;